import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkCreateTaxRegionRequest = { taxRegions: '_taxRegion' };
var _bulkCreateTaxRegionResponse = { results: '_bulkCreateTaxRegionResult' };
var _bulkCreateTaxRegionResult = { item: '_taxRegion' };
var _createTaxRegionRequest = { taxRegion: '_taxRegion' };
var _createTaxRegionResponse = { taxRegion: '_taxRegion' };
var _deleteTaxRegionRequest = {};
var _deleteTaxRegionResponse = {};
var _getTaxRegionRequest = {};
var _getTaxRegionResponse = { taxRegion: '_taxRegion' };
var _queryTaxRegionsRequest = {};
var _queryTaxRegionsResponse = { taxRegions: '_taxRegion' };
var _taxRegion = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _updateTaxRegionRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    taxRegion: '_taxRegion',
};
var _updateTaxRegionResponse = { taxRegion: '_taxRegion' };
function resolveWixBillingV1TaxRegionsServiceUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/billing/v1/tax-regions',
                destPath: '/v1/tax-regions',
            },
            {
                srcPath: '/billing/v1/bulk/tax-regions',
                destPath: '/v1/bulk/tax-regions',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/billing/v1/tax-regions',
                destPath: '/v1/tax-regions',
            },
            {
                srcPath: '/billing/v1/bulk/tax-regions',
                destPath: '/v1/bulk/tax-regions',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a tax region.
 *
 * Tax regions require a tax calculator `appId`. Use
 * [List Tax Calculators](https://dev.wix.com/docs/rest/business-management/payments/tax/tax-calculation/list-tax-calculators)
 * to retrieve a list of available calculators for a site.
 *
 * Wix uses tax regions to [calculate tax](https://dev.wix.com/docs/rest/business-management/payments/tax/tax-calculation/calculate-tax).
 * Subdivisions are supported for the following countries: `AU`, `BR`, `CA`, `FR`, `DE`, `IN`, `IT`, `MX`, `NL`, `ES`, `AE`, `GB`, `US`
 */
export function createTaxRegion(payload) {
    var _a = serializer(_createTaxRegionRequest, { _taxRegion: _taxRegion }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createTaxRegionResponse, {
        _taxRegion: _taxRegion,
    }).fromJSON;
    function __createTaxRegion(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.tax_region',
            method: 'POST',
            methodFqn: 'wix.billing.v1.TaxRegionsService.CreateTaxRegion',
            url: resolveWixBillingV1TaxRegionsServiceUrl({
                protoPath: '/v1/tax-regions',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createTaxRegion.fromReq = fromReq;
    __createTaxRegion.__isAmbassador = true;
    return __createTaxRegion;
}
/** Create multiple Tax Regions by Bulk */
export function bulkCreateTaxRegion(payload) {
    var _a = serializer(_bulkCreateTaxRegionRequest, { _taxRegion: _taxRegion }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateTaxRegionResponse, {
        _bulkCreateTaxRegionResult: _bulkCreateTaxRegionResult,
        _taxRegion: _taxRegion,
    }).fromJSON;
    function __bulkCreateTaxRegion(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.tax_region',
            method: 'POST',
            methodFqn: 'wix.billing.v1.TaxRegionsService.BulkCreateTaxRegion',
            url: resolveWixBillingV1TaxRegionsServiceUrl({
                protoPath: '/v1/bulk/tax-regions/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateTaxRegion.fromReq = fromReq;
    __bulkCreateTaxRegion.__isAmbassador = true;
    return __bulkCreateTaxRegion;
}
/** Retrieves a tax region. */
export function getTaxRegion(payload) {
    var _a = serializer(_getTaxRegionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getTaxRegionResponse, {
        _taxRegion: _taxRegion,
    }).fromJSON;
    function __getTaxRegion(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.tax_region',
            method: 'GET',
            methodFqn: 'wix.billing.v1.TaxRegionsService.GetTaxRegion',
            url: resolveWixBillingV1TaxRegionsServiceUrl({
                protoPath: '/v1/tax-regions/{taxRegionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getTaxRegion.fromReq = fromReq;
    __getTaxRegion.__isAmbassador = true;
    return __getTaxRegion;
}
/**
 * Updates a tax region.
 *
 * Each time the tax region is updated, `revision` increments by 1.
 * The current `revision` must be passed when updating the tax region.
 * This ensures you're working with the latest tax region and prevents
 * unintended overwrites.
 */
export function updateTaxRegion(payload) {
    var _a = serializer(_updateTaxRegionRequest, { _taxRegion: _taxRegion }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateTaxRegionResponse, {
        _taxRegion: _taxRegion,
    }).fromJSON;
    function __updateTaxRegion(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.tax_region',
            method: 'PATCH',
            methodFqn: 'wix.billing.v1.TaxRegionsService.UpdateTaxRegion',
            url: resolveWixBillingV1TaxRegionsServiceUrl({
                protoPath: '/v1/tax-regions/{taxRegion.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateTaxRegion.fromReq = fromReq;
    __updateTaxRegion.__isAmbassador = true;
    return __updateTaxRegion;
}
/**
 * Deletes a tax region.
 *
 * When a tax region is deleted, tax is not calculated and zero tax will be returned for addresses in this region.
 */
export function deleteTaxRegion(payload) {
    var _a = serializer(_deleteTaxRegionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteTaxRegionResponse, {}).fromJSON;
    function __deleteTaxRegion(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.tax_region',
            method: 'DELETE',
            methodFqn: 'wix.billing.v1.TaxRegionsService.DeleteTaxRegion',
            url: resolveWixBillingV1TaxRegionsServiceUrl({
                protoPath: '/v1/tax-regions/{taxRegionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteTaxRegion.fromReq = fromReq;
    __deleteTaxRegion.__isAmbassador = true;
    return __deleteTaxRegion;
}
/**
 * Retrieves a list of tax regions, given the provided paging, filtering, and sorting.
 *
 * For field support for filters and sorting, see [Tax Regions: Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-management/payments/tax/tax-regions/supported-filters-and-sorting).
 *
 * To learn about working with _Query_ endpoints, see
 * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
 * [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/sorting-and-paging),
 * and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 */
export function queryTaxRegions(payload) {
    var _a = serializer(_queryTaxRegionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryTaxRegionsResponse, {
        _taxRegion: _taxRegion,
    }).fromJSON;
    function __queryTaxRegions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.tax_region',
            method: 'POST',
            methodFqn: 'wix.billing.v1.TaxRegionsService.QueryTaxRegions',
            url: resolveWixBillingV1TaxRegionsServiceUrl({
                protoPath: '/v1/tax-regions/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryTaxRegions.fromReq = fromReq;
    __queryTaxRegions.__isAmbassador = true;
    return __queryTaxRegions;
}
//# sourceMappingURL=http.impl.js.map